import Repository from '@/repositories/marketing'
const resource = '/brands'

export default {
    fetch (config) {
        return Repository.get(`${resource}`, config)
    },
    create (payload) {
        return Repository.post(`${resource}`, payload)
    },
    update (payload, id) {
        return Repository.put(`${resource}/${id}`, payload)
    },
    getLinkDomainList (config) {
        return Repository.get(`link_tracking_domains.json`, config)
    },
    getDkimDomainList (config) {
        return Repository.get(`dkim_domains.json`, config)
    },
    getMailSpreaderList () {
        return Repository.get(`${resource}/mail_spreader_ips`)
    },
    getBrandById(id,config){
        return Repository.get(`${resource}/${id}.json`,config)
    },
}
